import apiConfig from "@/config/apiConfig";
import {getAction} from "@/utils/http/service";

const rootPath = apiConfig.financeApi;
export const common_controller = {
    getDictDataByGroupNumber: rootPath + "/systemDictData/getListByGroupNumbers", // 根据分组编号查询字典项(get)
}

export const getDict = (dictName) => {
    return new Promise(resolve => {
        getAction({
            url: common_controller.getDictDataByGroupNumber,
            params: {
                groupNumbers: dictName
            }
        }).then(res => {
            resolve(list2Obj(res))
        })
    })
}

export const getMultipleDict = (dictNames) => {

    let dictNameArray = dictNames.split(",")

    let isMultiple = dictNameArray.length > 1;

    return new Promise(resolve => {
        getAction({
            url: common_controller.getDictDataByGroupNumber,
            params: {
                groupNumbers: dictNames
            }
        }).then(res => {
            if(isMultiple) {
                let multipleMap = {};
                dictNameArray.forEach(item => {
                    multipleMap[item] = list2Obj(res[item])
                })
                resolve(multipleMap)
            } else {
                resolve({[dictNames]: list2Obj(res)})
            }
        })
    })
}


/**
 * 列表数据转换为 {list: [], obj: {}}
 * @param resDate
 */
let list2Obj = (resDate) => {
    let resObj = {};
    resDate.forEach(v => {
        resObj[v.dictValue + ''] = v.dictLabel;
        resObj[v.dictValue + '_dict'] = v;
    })
    return {
        list: resDate,
        obj: resObj
    }
}
